import { Box, Flex, Skeleton } from '@chakra-ui/react';

const PageLoader = function () {
  return (
    <Flex w='full' justifyContent='center'>
      <Box
        w='full'
        maxW='750px'
        borderRadius='20px'
        px={{ base: '0px', sm: '40px' }}
        py={{ base: '0px', sm: '46px' }}
        boxShadow={{ base: 'none', md: '0px 0px 4px 0px rgba(0, 0, 0, 0.48)' }}
      >
        <Flex py='0.5' flexDir='column'>
          <Skeleton width='full' height={{ base: '224px', md: '149px' }} borderRadius='8px' />
          <Flex w='full' mt='8' px={{ base: '4', md: '8' }} alignItems='center' gap='4'>
            <Skeleton display={{ base: 'none', md: 'block' }} height='16px' width='80px' borderRadius='8px' />
            <Flex gap={{ base: '2', md: '4' }} width='full' flexDir={{ base: 'column', md: 'row' }}>
              <Skeleton height='40px' width='full' borderRadius='8px' />
              <Skeleton height='40px' width='full' borderRadius='8px' />
              <Skeleton height='40px' width='full' borderRadius='8px' />
            </Flex>
          </Flex>
        </Flex>
      </Box>
    </Flex>
  );
};

export default PageLoader;
